import {ApiClient} from "../generated/ApiClient";
import {Aborted, useFetcher} from "./useFetcher";

export const usePodcastRecommendedKey = () => ({
    queryKey: ["usePodcastRecommendedKey"],
    queryFn: useFetcher(() => new ApiClient().getApiPodcastRecommendedPrograms({},{
        credentials: "include",
        signal: Aborted().signal
    })),
})